var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallpaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.977,
    cy: 32.869,
    r: 10.131,
    fill: "#2979ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.224,
    cy: 24.218,
    r: 10.131,
    fill: "#4527a0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.355,
    cy: 15.349,
    r: 10.131,
    fill: "#b71c1c"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.24,
    cy: 15.131,
    r: 10.131,
    fill: "#e53935"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.994,
    cy: 23.782,
    r: 10.131,
    fill: "#fdd835"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.863,
    cy: 32.651,
    r: 10.131,
    fill: "#2e7d32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7e57c2",
    d: "M24.129,24.01c0.12,0.06,0.24,0.14,0.36,0.22c-0.12-0.06-0.25-0.13-0.37-0.21 c0,0.17,0,0.34-0.02,0.52c-0.01-0.17-0.01-0.34,0-0.51c-0.15,0.08-0.31,0.16-0.47,0.23c0.15-0.09,0.3-0.18,0.46-0.27h0.02 c0,0,0-0.01,0.01-0.02c0.15-0.08,0.31-0.16,0.47-0.23C24.439,23.83,24.289,23.92,24.129,24.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M39.109,32.87v0.22c-3.01,1.65-6.77,1.74-9.95-0.1c-0.06-0.03-0.12-0.07-0.17-0.11l-4.5-8.65 l9.76-0.02C37.159,26,39.109,29.2,39.109,32.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7e57c2",
    d: "M24.129,24.01c0.12,0.06,0.24,0.14,0.36,0.22c-0.12-0.06-0.25-0.13-0.37-0.21 c0,0.17,0,0.34-0.02,0.52c-0.01-0.17-0.01-0.34,0-0.51c-0.01-0.01-0.01-0.02,0-0.03v-0.02c0-0.17,0-0.34,0.02-0.52 c0.01,0.17,0.01,0.34,0,0.51c0.15-0.08,0.31-0.16,0.47-0.23C24.439,23.83,24.289,23.92,24.129,24.01z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8e24aa",
    d: "M39.479,15.56c-0.07,3.42-1.88,6.73-5.06,8.56c-0.06,0.03-0.11,0.06-0.17,0.09l-9.66-0.47l4.78-8.41 c3-1.64,6.75-1.72,9.92,0.11C39.359,15.48,39.419,15.52,39.479,15.56z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M34.249,24.21c-3.14,1.74-6.81,1.64-9.76,0.02c-0.12-0.08-0.24-0.16-0.36-0.22 c0.16-0.09,0.31-0.18,0.46-0.27c1.33-0.64,2.82-1,4.39-1C30.909,22.74,32.709,23.28,34.249,24.21z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7e57c2",
    d: "M24.129,24.01c0.12,0.06,0.24,0.14,0.36,0.22c-0.12-0.06-0.25-0.13-0.37-0.21v-0.01 c-0.01,0.01-0.01,0-0.02-0.01c0,0-0.01,0.01-0.01-0.01c-0.12-0.06-0.24-0.14-0.36-0.22c0.12,0.06,0.25,0.13,0.37,0.21 c0-0.17,0-0.34,0.02-0.52c0.01,0.17,0.01,0.34,0,0.51c0.15-0.08,0.31-0.16,0.47-0.23C24.439,23.83,24.289,23.92,24.129,24.01z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d32f2f",
    d: "M29.369,15.13v0.2l-5.25,8.13l-4.89-8.34c0.07-3.42,1.88-6.71,5.06-8.54 c0.07-0.04,0.14-0.08,0.21-0.11C27.419,8.25,29.369,11.46,29.369,15.13z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M29.369,15.33c-0.07,3.55-1.96,6.66-4.78,8.41c-0.16,0.07-0.32,0.15-0.47,0.23 c0.01-0.17,0.01-0.34,0-0.51c0.11-1.47,0.54-2.94,1.33-4.31C26.419,17.48,27.789,16.18,29.369,15.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7e57c2",
    d: "M24.589,23.74c-0.15,0.09-0.3,0.18-0.46,0.27h-0.01v0.01c-0.01,0-0.01,0-0.02,0.01 c-0.15,0.08-0.31,0.16-0.47,0.23c0.15-0.09,0.3-0.18,0.46-0.27c-0.12-0.06-0.24-0.14-0.36-0.22c0.12,0.06,0.25,0.13,0.37,0.21 c0-0.17,0-0.34,0.02-0.52c0.01,0.17,0.01,0.34,0,0.51C24.269,23.89,24.429,23.81,24.589,23.74z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M23.729,23.77l-9.76,0.02c-2.91-1.79-4.86-4.99-4.86-8.66v-0.22c3.01-1.65,6.77-1.74,9.95,0.1 c0.06,0.03,0.12,0.07,0.17,0.11L23.729,23.77z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5252",
    d: "M24.119,23.46c-0.02,0.18-0.02,0.35-0.02,0.52c-0.12-0.08-0.25-0.15-0.37-0.21 c-1.26-0.83-2.34-1.96-3.15-3.36c-0.97-1.67-1.4-3.5-1.35-5.29C22.269,16.95,24.019,20.14,24.119,23.46z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7e57c2",
    d: "M24.119,23.46c0.01,0.17,0.01,0.34,0,0.51c0.01,0.01,0.01,0.02,0,0.03v0.02c0,0.17,0,0.34-0.02,0.52 c-0.01-0.17-0.01-0.34,0-0.51c-0.15,0.08-0.31,0.16-0.47,0.23c0.15-0.09,0.3-0.18,0.46-0.27c-0.12-0.06-0.24-0.14-0.36-0.22 c0.12,0.06,0.25,0.13,0.37,0.21C24.099,23.81,24.099,23.64,24.119,23.46z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9d24",
    d: "M23.629,24.26l-4.78,8.41c-3,1.64-6.75,1.72-9.92-0.11c-0.07-0.04-0.13-0.08-0.19-0.12 c0.07-3.42,1.88-6.73,5.06-8.56c0.06-0.03,0.11-0.06,0.17-0.09L23.629,24.26z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00796b",
    d: "M28.989,32.88c-0.07,3.42-1.88,6.71-5.06,8.54c-0.07,0.04-0.14,0.08-0.21,0.11 c-2.92-1.78-4.87-4.99-4.87-8.66v-0.2l5.25-8.13L28.989,32.88z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    d: "M28.989,32.88c-3.04-1.83-4.79-5.02-4.89-8.34c0.02-0.18,0.02-0.35,0.02-0.52 c0.12,0.08,0.25,0.15,0.37,0.21c1.26,0.83,2.34,1.96,3.15,3.36C28.609,29.26,29.039,31.09,28.989,32.88z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M24.099,24.03c-0.01,0.17-0.01,0.34,0,0.51c-0.11,1.47-0.54,2.94-1.33,4.31 c-0.97,1.67-2.34,2.97-3.92,3.82c0.07-3.55,1.96-6.66,4.78-8.41C23.789,24.19,23.949,24.11,24.099,24.03z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M24.089,23.99c-0.16,0.09-0.31,0.18-0.46,0.27c-1.33,0.64-2.82,1-4.39,1 c-1.93,0-3.73-0.54-5.27-1.47c3.14-1.74,6.81-1.64,9.76-0.02C23.849,23.85,23.969,23.93,24.089,23.99z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#7e57c2",
    d: "M24.489,24.23c-0.12-0.06-0.25-0.13-0.37-0.21c0,0.17,0,0.34-0.02,0.52c-0.01-0.17-0.01-0.34,0-0.51 c-0.15,0.08-0.31,0.16-0.47,0.23c0.15-0.09,0.3-0.18,0.46-0.27c-0.12-0.06-0.24-0.14-0.36-0.22c0.12,0.06,0.25,0.13,0.37,0.21v0.01 h0.01c0,0,0,0,0.01,0.01c0,0,0.01-0.01,0.01,0.01C24.249,24.07,24.369,24.15,24.489,24.23z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallpaper);
export default __webpack_public_path__ + "static/media/wallpaper.af1461dfb77f73259978319b6bf33e09.svg";
export { ForwardRef as ReactComponent };